import React, { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Outlet } from 'react-router-dom'
import { myAccount } from 'services/api/authentication'
import ReactGA from 'react-ga4'

export const authContext = createContext({})

const AuthProvider = () => {
  const [auth, setAuth] = useState({
    data: {},
  })
  const { refetch: setAuthData } = useQuery(
    'myAccountData',
    async () => {
      const { data } = await myAccount()
      return data
    },
    {
      onSuccess: (res) => {
        setAuth({ data: res })
        // Bugsnag removed - errors will now appear in console
        ReactGA.set({
          tenant_id: res.organization_detail.tenant_id,
          company_name: res.organization_detail.organization_name,
        })
      },
      onError: (err) => {
        setAuth({
          data: {},
        })
        // Log error to console instead of Bugsnag
        console.error('Auth error:', err)
      },
    }
  )

  useEffect(() => {
    setAuthData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <authContext.Provider value={{ auth, setAuthData }}>
      <Outlet />
    </authContext.Provider>
  )
}

export default AuthProvider
